import styled, { css } from 'styled-components';
import { animated } from 'react-spring';
import { device } from '../../../styles/devices';
import { COLORS, SIZING } from '../../../styles/variables';

export const OtherMakeGroupWrapper = styled(animated.div)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

export const ShowAllButton = styled.button`
  color: ${COLORS.grey60};
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  border: none;
  border-bottom: 1px solid ${COLORS.grey60};
  padding-bottom: 2px;
  cursor: pointer;
  background-color: transparent;
`;

export const AllMakesWrapper = styled.div<{ expanded?: boolean; contentHeight?: string }>`
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow: hidden;
  transition:
    max-height 1s ease,
    opacity 0.5s ease,
    margin-top 1.5s ease;
  max-height: ${({ expanded, contentHeight }) =>
    expanded && contentHeight ? contentHeight : 'auto'};
`;

export const MakeCheckbox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const MakesCount = styled.div`
  color: ${COLORS.grey60};
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
`;

export const GroupMakeLabel = styled.h5`
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey60};
  padding-bottom: 12px;
`;
